import LocationManualToggle from './LocationManualToggle';

export default LocationManualToggle;
